import axios from 'axios';

export default axios.create({
  //baseURL: 'http://localhost:9000/api/v1',
  //baseURL: 'https://www.astelcommachala.com:8000/api/v1',
  baseURL: 'https://www.apps.whatsivo.com/whapi/api/v1',
});